import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { getPostDayLabel } from '@/features/posts/utils/getPostDayLabel';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    text: {
      color: theme.colors.outline,
      marginTop: 16,
      marginBottom: 8
    }
  });

type Props = { dayStart: number };

export const OrganizationPostDateSectionHeader: FC<Props> = ({ dayStart }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const { t } = useTranslation(LocalizationNameSpace.POSTS);
  const label = useMemo(() => getPostDayLabel(dayStart, t), [dayStart, t]);

  return (
    <Text variant="labelLarge" style={styles.text}>
      {label}
    </Text>
  );
};
